import Vue from 'vue'
import moment from 'moment-timezone'

moment.tz.setDefault('America/Santiago')
moment.locale('es')

export const momento = moment 

Vue.prototype.$moment = momento